import React from "react";
import { HashRouter } from "react-router-dom";
import { routes } from "./../config/routes";
import "intl";
import { IntlProvider } from "react-intl";
import { Provider } from "react-redux";
import { AppInfoWrapper } from "../utils/AppInfoWrapper";
import { LegalContracts } from "../components/LegalContracts/LegalContracts";

const Root = (props) => {
  return (
    <Provider store={props.store}>
      <IntlProvider locale="es">
        <React.Fragment>
          <LegalContracts />
          <AppInfoWrapper>
            <HashRouter>{routes}</HashRouter>
          </AppInfoWrapper>
        </React.Fragment>
      </IntlProvider>
    </Provider>
  );
};

export default Root;
